<template>
  
  <div>
    

    <div v-if="is_super_admin" class="main_div">
      <div> 

        <div style="margin-bottom: 20px; float:left;"> 
          <el-button type="primary" plain @click="add_play_btn_func" size="small" style="height:50px">新增玩法</el-button>
        </div>

        <div style="margin-bottom: 20px; float:left; margin-left: 20px;">
          <el-alert
            title="消息提示的文案"
            style="height:50px"
            type="warning"
            description="玩法名不可重复,不可修改,如需修改某玩法名,请删除后重新添加"
            show-icon
            :closable="false">
          </el-alert> 
        </div>

      </div>

      <el-table
        :data="l_paly_table_data"
        style="width: 100%">

        <el-table-column
          label="玩法名称"
          width="180"
          align="center"
          >
          <template slot-scope="scope">
            <span style="margin-left: 10px">{{ scope.row.play_name }}</span>
          </template>
        </el-table-column>


        <el-table-column
          label="玩法说明"
          align="center">

          <template slot-scope="scope" class="play_detail_style">
            <span class="play_detail_style" style="width:auto; display:block; text-align:left;">{{ scope.row.play_detail }}</span>
          </template>
        </el-table-column>

        <el-table-column label="操作" align="center" fixed="right" width="150">
          <template slot-scope="scope">
            <el-button
              size="mini"
              @click="paly_edit(scope.$index, scope.row)">编辑</el-button>
            <el-button
              size="mini"
              type="danger"
              @click="paly_delete_btn(scope.$index, scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 新增玩法 -->
      <el-dialog :visible.sync="b_show_dialog" :fullscreen="b_show_fullscreen" :before-close="this.$dialog_close" :show-close="false">
        
        <div slot="title" class="dialog-title">
          <span style="font-size: 18px; line-height: 24px; color: #303133;">新增玩法</span>
          
          <el-button icon="el-icon-close" class='dialog-title-button' @click="not_add_play"></el-button>
          <el-button icon="el-icon-full-screen" class='dialog-title-button' @click="b_show_fullscreen = !b_show_fullscreen"></el-button>
          
        </div>
          <el-form :model="d_add_form" :rules="rules" ref="d_add_form" label-width="100px" class="demo-d_add_form">
            <el-form-item label="玩法名称" prop="play_name" >
              <el-input v-model="d_add_form.play_name" placeholder="请输入玩法名称" :disabled="b_disabled"></el-input>
            </el-form-item>
            <el-form-item label="玩法说明" prop="play_name" >
              <el-input
                type="textarea"
                :autosize="{ minRows: 2, maxRows: 15}"
                placeholder="请输入内容"
                v-model="d_add_form.play_detail">
              </el-input>
            </el-form-item>
            <el-form-item label="玩法图片" prop="play_name" >
              <el-upload
              
                action= ''
                list-type="picture-card"
                ref='upload'
                :before-remove="remove_play_img"
                :limit=1
                :http-request="upload_play_img"
                :file-list="play_img_list">

                <i class="el-icon-plus"></i>
              </el-upload>

            </el-form-item>


          </el-form>
        <div slot="footer" class="dialog-footer">
          
          <el-button type="primary" @click="not_add_play">取 消</el-button>
          <el-button type="primary" @click="add_play">确 定</el-button>
        </div>
        
        
      </el-dialog>

    </div>

    <div v-else>
      <div style="text-align: center;">
        <div style="margin-top: 0px;">
          <img src="../../assets/permission_denied.png">
          <div style="margin-top: 20px;">
            <span style="font-size: 18px; line-height: 24px; color: #303133;">您没有权限访问该页面</span>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
  export default {
    data() {
      return {
        b_disabled: false,
        ref_components: 1,
        b_show_dialog: false,
        b_show_fullscreen: false,
        l_paly_table_data: [],

        play_img_list: [],
        is_super_admin: false,

				// 当前表单操作状态 1:新增, 2:编辑
				i_form_type: 1,

        d_add_form: {
          'play_name': '',
          'play_detail': '',
        },
        rules: {}
      }
    },

		mounted(){
      // 判断当前用户是否是超级管理员, 如果不是超级管理员, 页面提示无权限操作
      let isSuperAdmin = window.sessionStorage.getItem("is_super_admin")
      if (isSuperAdmin == "false") {
        this.is_super_admin = false
        return
      } else {
        this.is_super_admin = true
      }
			// 请求玩法
			this.ref_play_table_data()

		},

    methods: {

			// 刷新表单数据
			async ref_play_table_data(){
				let _this = this
				let url = '/api/play_deploy/'
        let res = await this.$axios.get(url)
        this.l_paly_table_data = res.data
			},

      // 新增玩法
      add_play_btn_func(){

        // this.ref_components += 1
        this.play_img_list = []
        this.b_show_fullscreen = false
        this.b_show_dialog = true
        this.i_form_type = 1
				this.b_disabled = false
        // 重置表单数据
        this.d_add_form= {
          'play_name': '',
          'play_detail': '',
          'play_img': '',
        }
        
      },

      // 取消
      not_add_play(){
        this.b_show_dialog = false
        this.reset_data()
      },

      // 添加玩法
      async add_play(){
				let url = '/api/play_deploy/'
				// 添加操作
				if (this.i_form_type === 1){
          console.log(this.d_add_form)

          let res = await this.$axios.post(url, this.d_add_form)
          this.request_waring(res)

				}
				// 编辑操作
				else if (this.i_form_type === 2){
				
					let play_id = this.d_add_form.play_id
					let url = '/api/play_deploy/' + play_id + '/'

          let res = await this.$axios.patch(url, this.d_add_form)
          this.request_waring(res)
				}
			
      },

      // 请求警告
      request_waring(res){
        if (res.status === 201 || res.status === 200){
          this.$message({
            message: '保存成功',
            type: 'success'
          })
          this.b_show_dialog = false
          this.ref_play_table_data()
          
        } else {
          this.$message({
            message: '保存失败',
            type: 'error'
          })
        }
        // 重置数据
        this.reset_data()
      },

      // 重置数据
      reset_data(){
        this.d_add_form = {
          'play_name': '',
          'play_detail': '',
          'play_img': '',
        }
        this.play_img_list = []
      },

			// 编辑玩法
      paly_edit(index, row) {
        console.log(index, row);
        this.play_img_list = [{url: row.play_img}]
				this.d_add_form = JSON.parse(JSON.stringify(row))
        
        console.log(this.d_add_form)
        console.log(this.play_img_list)

				this.b_show_fullscreen = false
        this.b_show_dialog = true
				this.i_form_type = 2
				this.b_disabled = true
      },

			// 删除操作
			paly_delete_btn(index, row){
				let _this = this
				console.log(row)
				this.$confirm('此操作将永久删除 (' + row.play_name + ') 玩法, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
					let data = JSON.parse(JSON.stringify(row))
					let play_name = data.play_name
					let play_id = data.play_id
					let url = '/api/play_deploy/' + play_id + '/'
					_this.$axios.delete(url).then(res=>{
						console.log(res)
						_this.ref_play_table_data()
						this.$notify({
							type: 'success',
							title: '成功',
							message: '删除玩法 (' + play_name + ') 成功!'
          	});

						}).catch(err=>{
							console.log(err)
							this.$notify.error({
								type: 'success',
								title: '失败',
								message: '删除玩法 (' + row.play_name + ') 失败!'
          		});
					})

        }).catch(() => {
          this.$notify({
            title: '取消',
            message: '取消删除玩法 (' + row.play_name + ')',
						type: 'info'
          });          
        });
			},

      paly_delete(index, row) {
        console.log(index, row);
				let data = JSON.parse(JSON.stringify(row))
				let play_name = data.play_name
				let url = '/api/play_deploy/' + play_name + '/'

				_this.$axios.delete(url).then(res=>{
					console.log(res)

				}).catch(err=>{
					console.log(err)
				})
      },

      // 上传图片事件
      async upload_play_img(option){
        let res = await this.$upload_common(option)
        console.log(res)
        this.d_add_form.play_img = res.data.s_url
        console.log(this.d_add_form)
      },

      // 删除图片事件
      async remove_play_img(){
        let s_remove_url = this.d_add_form.play_img
        await this.$remove_common(s_remove_url)
        this.d_add_form.play_img = ''
      },

    }
  }
</script>

<style>
.main_div {
  padding: 12px 16px;
}

.play_detail_style {
  text-align: right;
}
</style>